module.exports = __webpack_public_path__ + "static/media/pause_w.09b6c51e.svg";